import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import HmdaLandingPage from '../../../hmda/HmdaLandingPage';

export default function HMDARoutes() {
    return (
        <>
            <Route
                path='/hmda'
                element={
                    <RequireAdmin>
                        <HmdaLandingPage />
                    </RequireAdmin>
                }
            />
        </>
    );
}
